import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const initialSavedItemsState = {
  userSavedItemsFolders: [],
  isLoadingSavedItemsList: true,
  savePopupItem: null,
  savePopupMultipleItems: null,
  showSavePopup: false,
  isLoadingFolder: true,
  savedItems: [],
  readyUserSavedItemsFolders: false,
  currentFolderSavedItems: {},
  saveItemsIds: [],
  reloadSavedItemsInformation: null,
  scrollPositionSavedItems: null,
};

const SavedItemsContext = createContext(null);

const SavedItemsProvider = ({ children, initialState }) => {
  const [state, setState] = useState(
    initialState ? { ...initialSavedItemsState, ...initialState } : initialSavedItemsState
  );

  const setSavedItemsState = useCallback((arg1, arg2) => {
    if (typeof arg1 === 'function') {
      setState(arg1);
    } else if (arg2 !== undefined) {
      setState((prev) => ({ ...prev, [arg1]: arg2 }));
    } else {
      setState((prev) => ({ ...prev, ...arg1 }));
    }
  }, []);

  const value = useMemo(() => [state, setSavedItemsState], [state, setSavedItemsState]);
  return <SavedItemsContext.Provider value={value}>{children}</SavedItemsContext.Provider>;
};

const useSavedItemsContext = () => {
  const ctx = useContext(SavedItemsContext);
  if (!ctx) {
    throw new Error('useSavedItemsContext must be used within a SavedItemsProvider');
  }
  const [state, setState] = ctx;
  return { state, setState };
};

export { SavedItemsProvider, useSavedItemsContext, initialSavedItemsState };

